import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import map from '../../node_modules/ramda/es/map.js';
import { WebsiteIcon, InstagramIcon, YoutubeIcon, TwitterIcon, InIcon, GIcon, FbIcon } from '../Icons/index.js';

var _templateObject, _templateObject2;
var SocialBox = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  background-color: transparent;\n"])));
var Link = styled.a.attrs({
  target: "_blank",
  rel: "noopener noreferrer"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var socialIcons = {
  facebook: function facebook(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(FbIcon, null));
  },
  google: function google(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(GIcon, null));
  },
  linkedin: function linkedin(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(InIcon, null));
  },
  twitter: function twitter(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(TwitterIcon, null));
  },
  youtube: function youtube(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(YoutubeIcon, null));
  },
  instagram: function instagram(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(InstagramIcon, null));
  },
  website: function website(link, id) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: id,
      href: link
    }, /*#__PURE__*/React__default.createElement(WebsiteIcon, null));
  }
};
var SocialNetworks = (function (_ref) {
  var networks = _ref.networks;
  return /*#__PURE__*/React__default.createElement(SocialBox, null, map(function (_ref2) {
    var name = _ref2.name,
      link = _ref2.link,
      id = _ref2.id;
    return socialIcons[name](link, id);
  }, networks));
});

export { Link, SocialNetworks as default, socialIcons };
